import { render, staticRenderFns } from "./platChart.vue?vue&type=template&id=0e07d6e2"
import script from "./platChart.vue?vue&type=script&lang=js"
export * from "./platChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports